import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getMemberPoints = createSelector(membersState, (members) => members.data?.MemberPoints || null);
